<template>
  <div class="col-12">
    <div class="row align-items-top">
      <div class="col-md-2 border-sm-top  striped-sm">
        OS: &nbsp;&nbsp;&nbsp;<div class="d-none d-md-block"></div><strong>
          {{ execucao.nr_sequencial }}
        </strong>
      </div>
      <div class="col-md-2 border-sm-top ">
        {{ $t('Placa') }}: &nbsp;&nbsp;&nbsp;<div class="d-none d-md-block"></div><strong>
          {{ execucao.nr_placa }}
        </strong>
      </div>
      <div class="col-md-3 border-sm-top  striped-sm">
        {{ $t('Início Atendimento OS') }}: &nbsp;&nbsp;&nbsp;<div class="d-none d-md-block"></div><strong>
          {{ dataAtendimento }}
        </strong>
      </div>
      <div class="col-md-3  striped-sm">
        {{ $t('Problema') }}: &nbsp;&nbsp;&nbsp;<div class="d-none d-md-block"></div>
        <strong v-if="execucao.ds_conjunto">{{ execucao.ds_conjunto }} </strong>
      </div>
      <div class="col-md-2  striped-sm">
        {{ $t('Serviço') }}: &nbsp;&nbsp;&nbsp;<div class="d-none d-md-block"></div>
        <strong v-if="execucao.ds_grupo">{{ execucao.ds_grupo }} </strong>
      </div>

    </div>
    <div class="row align-items-top mt-3">
      <div class="col-md-2 striped-sm">
        {{ $t('Colaborador') }}: &nbsp;&nbsp;&nbsp;<div class="d-none d-md-block"></div>
        <strong>{{ execucao.ds_colaborador }} </strong>
      </div>
      <div class="col-md-5 striped-sm">
        {{ $t('Motivo') }}: &nbsp;&nbsp;&nbsp;<div class="d-none d-md-block"></div>
        <strong>{{ execucao.execucao_inicio_pause[0].justificativa_pause }} </strong>
      </div>
      <div class="col-md-3 striped-sm">
        {{ $t('Observação') }}: &nbsp;&nbsp;&nbsp;<div class="d-none d-md-block"></div>
        <strong>{{ execucao.execucao_inicio_pause[0].observacao }} </strong>
      </div>
      <div class="col-md-2 text-left  striped-sm">
        <div class="d-block d-md-none mt-3"></div>
        <router-link class="btn btn-success m-2" :to="'os/' + execucao.nr_sequencial">
          <i class="fas fa-sign-out-alt"></i> {{ $t('Acessar OS') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    execucao: {},
    exibeParar: {}
  },
  data() {
    return { items: '', idConjunto: '', inputOptions: '', show: false, selectServico: '', ds_tipo: '', showModalItems: false, cod_item: ''}
  },
  computed: {
    dataAtendimento() {
      if(this.execucao.dt_inicial){ 
        var data = this.execucao.dt_inicial
        var dia = data.substring(8, 10)
        var mes = data.substring(5, 7)
        var ano = data.substring(0, 4)
        var hora = data.substring(11, 13)
        var minutos = data.substring(14, 16)

        return dia + '/' + mes + '/' + ano + ' ' + hora + ':' + minutos
      } else {
        return '00' + '/' + '00' + '/' + '0000' + ' ' + '00' + ':' + '00'
      }

    },
    bgBackground() {
      return true
    },
    // getHoursSlaAtual (){
    //   const data = new Date(this.execucao.dt_inicio)
    //   const horaAt = data.getHours()
    //   const minAt = data.getMinutes()

    //   const sla = this.execucao.item.os.conjunto.hr_sla

    //   const horaSla = sla.substring(0,2)
    //   const minSla = sla.substring(3,5)

    //   return `${parseInt(horaAt) + parseInt(horaSla)}:${parseInt(minAt) + parseInt(minSla)}:00`
    // }
  },
  created () {
    console.log(this.execucao)
  }
}
</script>